module.exports = __webpack_public_path__ + "img/Weapon_43.08fe5023.png";